module.exports = __webpack_public_path__ + "img/icon-dorm.0c2f2a53.svg";